import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";
import { BatchGuardianEmailRequest } from "./BatchGuardianEmailRequest";
import { BatchGuardianUpdateLanguageRequest } from "./BatchGuardianUpdateLanguageRequest";
import { GuardianImportPreviewRequest } from "./GuardianImportPreviewRequest";
import { ImportPreviewRequest } from "./ImportPreviewRequest";

@Injectable()
export class DataService_NotifyRegBatch {
	constructor(private httpclientService: HttpclientService) {}

	GuardianRegBatchFormatSelectList() {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/GuardianRegBatchFormatSelectList?";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianRegBatchGetExportInfo() {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/GuardianRegBatchGetExportInfo?";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianRegBatchExport(SchoolID, StudentActive, GuardianOption, GuardianActive, EmailOption, FormatOption, LanguageOptionID) {
		var postResult$ = new Subject();
		var url =
			"StudentGuardianNotification/GuardianRegBatchExport?SchoolID=" +
			SchoolID +
			"&StudentActive=" +
			StudentActive +
			"&GuardianOption=" +
			GuardianOption +
			"&GuardianActive=" +
			GuardianActive +
			"&EmailOption=" +
			EmailOption +
			"&FormatOption=" +
			FormatOption +
			"&LanguageOptionID=" +
			LanguageOptionID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadImportPreviewData(parms: ImportPreviewRequest) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/LoadImportPreviewData";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadImportPreviewNextStudent(StudentID) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/LoadImportPreviewNextStudent?StudentID=" + StudentID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BatchGuardianEmail(parms: BatchGuardianEmailRequest) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/BatchGuardianEmail";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadImportPreviewAll(parms: GuardianImportPreviewRequest) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/LoadImportPreviewAll";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailLogInfoSelectList(StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/EmailLogInfoSelectList?StartDate=" + StartDate + "&EndDate=" + EndDate;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	NotifyLanguageSelectList() {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/NotifyLanguageSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	BatchGuardianUpdateLanguage(parms: BatchGuardianUpdateLanguageRequest) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/BatchGuardianUpdateLanguage";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
